'use client';

import { FocusTrap } from 'focus-trap-react';
import { Modal } from '@/ui-components/molecules/Modal/Modal';
import { AppDownloadButtons, type DownloadButtonProps } from '@/ui-components/molecules/AppDownloadButtons/AppDownloadButtons';
import styles from './appdownloadmodal.module.scss';

const APP_DOWNLOAD_ITEMS: DownloadButtonProps[] = [
    {
        type: 'appleStore',
        badgeSrc: 'https://www.siriusxm.com/content/dam/sxm-com/logos/banners/Download_on_the_App_Store_Badge.svg',
        storeLink: {
            href: 'https://apps.apple.com/us/app/siriusxm-music-sports-news/id317951436',
            target: '_blank',
        },
    },
    {
        type: 'playStore',
        badgeSrc: 'https://www.siriusxm.com/content/dam/sxm-com/logos/banners/Google_Play_Store_badge_EN.svg',
        storeLink: {
            href: 'https://play.google.com/store/apps/details?id=com.sirius&hl=en_US',
            target: '_blank',
        },
    },
];

export interface AppDownloadModalProps {
    isOpen: boolean;
    onClose: () => void;
    qrCodeSrc: string;
}

export function AppDownloadModal({ isOpen, onClose, qrCodeSrc }: AppDownloadModalProps) {
    return (
        <FocusTrap
            active={isOpen}
            focusTrapOptions={{
                allowOutsideClick: true,
            }}
        >
            <Modal
                open={isOpen}
                onClose={onClose}
                variant="small"
                maxWidth={360}
                headline="Scan with your device to download the app"
                subhead="Available on the App Store and Google Play Store"
            >
                <div className={styles.qrSection}>
                    <img
                        src={qrCodeSrc}
                        alt="QR code to download the app"
                        width={168}
                        height={168}
                        className={styles.qrCode}
                    />
                    <AppDownloadButtons items={APP_DOWNLOAD_ITEMS} />
                </div>
            </Modal>
        </FocusTrap>
    );
}
